import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/api/staffRest/listAll',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/staffRest',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/staffRest',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/staffRest/' + data,
    method: 'delete',
    data,
  })
}
